<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/v8mRN0/tc-custom/9781538110485.jpg?1702540756036" alt="This image is the cover for the book Gut Feeling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gut Feeling
      </h1>
      <p class="bookDescription body article font2">
        <p>“<b>An inspiring account of the enormous power that diet has to change the trajectory of our health.” —Erica D. Sonnenburg, senior research scientist, Stanford University School of Medicine</b><br/><br/> We all know sugar is bad for us, so why can’t we stop eating it? <i>A Gut Feeling</i> gives a personal and scientific look into the world of microbes that live within our bodies and how they can explain our relationship to and cravings for certain foods. <br/><br/> The microbiome is emerging as the answer to many of our most sought after questions. Using her own story and the science currently available, Heather Wise provides a window into the latest research on the vast world of microbes in our bodies. She explains in simple terms how what we eat can change the expression of our genes and how this symbiotic relationship between microbes and human cells can determine our health. <br/><br/><i>A Gut Feeling</i> offers practical steps to rebalancing and healing our gut microbiome to relieve stress, digestive upsets, inflammation, bloat, excess belly fat, and improve mood. Wise offers a needed alternative to the complex world of fad diets and calorie counting in this easy, evidence-based guide for wellbeing. Rooted in scientific research and providing a number of healthy sweet fixes high in prebiotic and probiotic foods that support the growth of healthy gut flora, this book is a practical guide to help heal our relationship with food and tune into what our gut has been trying to tell us.<br/>  <br/>  “Wise connects [the research] to real-life examples and ends each chapter with a short list of ‘Takeaways,’ which reinforce key concepts.” ―<i>Booklist</i><br/>   </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather Anne Wise
      </h2>
      
      <p class="authorDescription body article">Heather Anne Wise, MPH is a certified holistic health coach, wellness consultant, herbalist and avid food fermenter. Founder of Smart Palate wellness coaching, she has given a number of workshops and talks on gut health and well-being, including at Harvard Medical School. Heather lives with her family in the Boston area.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Rowman & Littlefield
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ea971088